export default function Button({
  children,
  variant = "primary",
  className = "",
  type = "button",
  ...props
}) {
  const variants = {
    primary: "bg-civic-blue text-white hover:bg-blue-800",
    secondary: "bg-white text-civic-navy ring-1 ring-civic-line hover:bg-slate-50",
    muted: "bg-slate-100 text-slate-800 hover:bg-slate-200",
    danger: "bg-signal-red text-white hover:bg-red-800"
  };

  return (
    <button
      type={type}
      className={`focus-ring inline-flex min-h-11 items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-semibold transition ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
